
import Vue from 'vue'

import { Auth, Hub, } from 'aws-amplify'

// Lib imports
import axios from 'axios'

import eventbus from './eventbus'

import moment from 'moment'
import tool_aws from './tool_aws'

// import tool_cookie from

// // let mIsInitialized = false;
// // async function onAuth(data) {
// //   console.log('A new auth event has happened: 1 ', data.payload.data.username + ' has ' + data.payload.event);
// //   console.log('A new auth event has happened: 2 ', data.payload);
// //   await Auth.currentAuthenticatedUser()
// //     .then(() => this.signedIn = true)
// //     .catch(() => this.signedIn = false);
// // }
// Vue.mixin({
//   data: function() {
//     return {
//       // get isSignedIn() {
//       //   return true;
//       // }
//       isSignedIn: false,
//     }
//   }
// });

function lg (...args) {
  tool_app.lg('tool_app] ', ...args);
}

function apicmd(comp, proc) {
  let cmdb = {
    modal: false,
  };
  cmdb.setShowProgressDialog = () => {
    cmdb.modal = true;
    comp.$modal.show({
        template: `
<div style="padding-left:10px; padding-right: 10px;">
          <v-progress-linear :indeterminate="true"></v-progress-linear>
</div>
      `,
        props: ['text', 'foo']
      }, {
        text: 'This text is passed as a property',
      }, {
        name: 'apicmd_progress',
        width: 200,
        height: 'auto',
        // clickToClose: false,
      },
    );
    return cmdb;
  };
  cmdb.send = () => {
    return new Promise(function (resolve, reject) {
      Auth.currentSession()
        .then(data => {
          lg('api 1 data: ', data);
          proc(resolve, reject, data);
        })
        .catch(err => {
          tool_app.ex(err);
          reject(err);
        })
        .finally(() => {
          if(cmdb.modal) {
            setTimeout(() => {
              comp.$modal.hide('apicmd_progress');
            }, 200);
          }
        });
    });
  };
  return cmdb;
}

const tool_app = {
  path_default: '/valetreservation',
  p: {
    mIsInitialized: false,
    mIsSignedIn: false,
    mIsAdmin: false,
    onAuth: function (data) {
      // lg('tool_app A new auth event has happened: 1 ', data.payload.data.username + ' has ' + data.payload.event);
      // lg('tool_app A new auth event has happened: 2 ', data.payload);
      Auth.currentAuthenticatedUser()
        .then((user) => {
          lg('onAuth then user:', user);
          tool_app.p.mIsSignedIn = true;
          if(user.username === 'myvalet') {
            tool_app.p.mIsAdmin = true;
          }
          else {
            tool_app.p.mIsAdmin = false;
          }
          eventbus.$emit(eventbus.Events.Signed, 'Hello');
        })
        .catch((e) => {
          lg('onAuth catch e:', e);
          tool_app.p.mIsSignedIn = false;
          eventbus.$emit(eventbus.Events.Signed, 'Hello');
        });
        // .then(() => this.isSignedIn = true)
        // .catch(() => this.isSignedIn = false);
    },
  },
  lg: function (...logs) {
    // let test = new Test();
    // test.asd();
    // console.log(arguments);
    if(tool_app.isDebug) {
      let args = Array.prototype.slice.call(arguments);
      console.log.apply(console, args);
    }
  },
  ex: function(err) {
    console.log(err);
  },
  isDebug: false,
  init: async function() {
    if(tool_app.p.mIsInitialized) {
      return;
    }
    tool_app.p.mIsInitialized = true;
    moment.locale('ko');

    // try {
    //   const user = await Auth.currentAuthenticatedUser();
    //   tool_app.p.mIsSignedIn = true;
    //   // this.isSignedIn = true;
    // } catch (err) {
    //   tool_app.p.mIsSignedIn = false;
    //   // this.isSignedIn = false;
    // }
    // eventbus.$emit(eventbus.Events.Signed, 'Hello');


    // AmplifyEventBus.$on('authState', info => {
    //   if (info === 'signedIn') {
    //     this.signedIn = true
    //   } else {
    //     this.signedIn = false
    //   }
    // });
    // console.log('beforeCreate 1', this.onAuth);
    Hub.listen('auth', tool_app.p.onAuth);
    lg('tool_app init 9 ');
  },
  destroy: function() {
    Hub.remove('auth', tool_app.p.onAuth);
  },
  isSignedIn: function() {
    lg('isSignedIn tool_app.p.mIsSignedIn:', tool_app.p.mIsSignedIn);

    return tool_app.p.mIsSignedIn;
  },
  isAdmin() {
    // lg('isAdmin ');
    return tool_app.p.mIsAdmin;
  },
  copy: function(obj) {
    return JSON.parse(JSON.stringify(obj));
  },
  showObject: function(obj) {
    return JSON.stringify(obj, null, 2);
  },
  padzero: function(num, size) {
    let s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
  },
  dateformat: function(date, df) {
    return moment(date).format(df);
  },
  numberWithCommas(x) {
    try {
      if(x) {
        // if(typeof x === "string") {
          return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        // }
      }
    }
    catch (e) {
    }
    return "0";
  },

  dialog_progress_show: function(comp) {
    comp.$modal.show({
        template: `
<div style="padding-left:10px; padding-right: 10px;">
          <v-progress-linear :indeterminate="true"></v-progress-linear>
</div>
      `,
        props: ['text', 'foo']
      }, {
        text: 'This text is passed as a property',
      }, {
        name: 'progress',
        width: 200,
        height: 'auto',
        // clickToClose: false,
      },
    );
  },
  dialog_progress_hide: function(comp) {
    setTimeout(() => {
      comp.$modal.hide('progress');
    }, 200);
  },

  async T_PeriodicCar_TaskHistory_add(comp, periodiccaridx, action, taskcontent, description) {
    let session = await tool_aws.getCurrentSession();
    lg('T_PeriodicCar_TaskHistory_add session:',session);
    let accountid = session.idToken.payload['cognito:username'];
    let accountname = comp.$cookies.get('accountname');

    tool_app.api(comp, `
      INSERT INTO T_PeriodicCar_TaskHistory
      (PeriodicCarIDX, Action, AccountID, AccountName,
      TaskContent, Description, DateTime_Task, IsExist, DateTime_Created, DateTime_Modified)
      VALUES (
      ?, ?, ?, ?, 
      ?, ?, NOW(), true, NOW(), NOW())
      `, [
          periodiccaridx, action, accountid, accountname,
          taskcontent, description,
        ])
          .send()
          .then((value) => {
            lg('insert into periodiccar_taskhistory 1 value:', value);
          })
          .catch((reason) => {
            tool_app.ex(reason);
          });
  },


  api: function (comp, q, p) {
    return apicmd(comp, (resolve, reject, data) => {
      q = q.replace(/\n/gi, " ");
      lg('api 1 q:', q, ' p:', p);
      axios({
        method: 'post', // you can set what request you want to be
        // url: 'https://b2mmnijy50.execute-api.ap-northeast-2.amazonaws.com/default/wework-lambda-debug-20190618',
        url: 'https://b2mmnijy50.execute-api.ap-northeast-2.amazonaws.com/default/center1-reservation-20190826',
        data: {
          isDebug: tool_app.isDebug,
          'c': 'console.log("asd");',
          // 'query': 'SELECT * FROM `table_name` ORDER BY column_1 DESC LIMIT 50',
          // 'params': [Math.random() * 10000],
          'database': 'myvalet_reservation',
          'query': q,
          'params': p,
          'greeter': 'asd',
        },
        headers: {
          'x-api-key': 'FzNOh8Zswn8vt0gJ8Rm8g6daOifpYrlz1EdrSYVM',
          'Content-Type': 'application/json',
          'Authorization': data.idToken.jwtToken,
        }
      })
        .then(function (response) {
          // response.data.pipe(fs.createWriteStream('ada_lovelace.jpg'))
          // lg('api 2 response: ', response);
          // if(tool_app.isDebug) {
          //   lg('api 2 log:\n', response.data.log);
          // }
          if(response.data.error) {
            // lg('api 2 error:\n', response.data.error);
            reject(response.data.error);
            return;
          }
          resolve(response);
          // console.log('response:', response)
          // response.data.results.forEach(function (element) {
          //   console.log(element)
          // })
        })
        .catch((reason) => {
          // TODO error dialog 띄워야 함
          lg('cmd 2 reason: ', reason);
          reject(reason);
        })
    });
  },
  cmd: function (comp, cmd, p) {
    return apicmd(comp, (resolve, reject, data) => {
      axios({
        method: 'post', // you can set what request you want to be
        // url: 'https://b2mmnijy50.execute-api.ap-northeast-2.amazonaws.com/default/wework-lambda-debug-20190618',
        url: 'https://b2mmnijy50.execute-api.ap-northeast-2.amazonaws.com/default/center1-reservation-20190826',
        data: {
          isDebug: tool_app.isDebug,
          'c': 'console.log("asd");',
          'cmd': cmd,
          'params': p,
          'greeter': 'asd',
        },
        headers: {
          'x-api-key': 'FzNOh8Zswn8vt0gJ8Rm8g6daOifpYrlz1EdrSYVM',
          'Content-Type': 'application/json',
          'Authorization': data.idToken.jwtToken,
        }
      })
        .then(function (response) {
          // lg('cmd 2 response: ', response);
          if(tool_app.isDebug) {
            lg('cmd 2 log:', response.data.log);
          }
          resolve(response);
        })
        .catch((reason) => {
          // TODO error dialog 띄워야 함
          lg('cmd 2 reason: ', reason);
        })
    });
//     let cmdb = {
//       modal: false,
//     };
//     cmdb.setShowProgressDialog = () => {
//       cmdb.modal = true;
//       comp.$modal.show({
//           template: `
// <div style="padding-left:10px; padding-right: 10px;">
//           <v-progress-linear :indeterminate="true"></v-progress-linear>
// </div>
//       `,
//           props: ['text', 'foo']
//         }, {
//           text: 'This text is passed as a property',
//         }, {
//           name: 'progress',
//           width: 200,
//           height: 'auto',
//           // clickToClose: false,
//         },
//       );
//       return cmdb;
//     };
//     cmdb.send = () => {
//       return new Promise(function (resolve, reject) {
//         Auth.currentSession()
//           .then(data => {
//             lg('api 1 data: ', data);
//
//             // {
//             //   "cmd": "ASD",
//             //   "params": [10000],
//             //   "greeter": "asd"
//             // }
//             axios({
//               method: 'post', // you can set what request you want to be
//               url: 'https://b2mmnijy50.execute-api.ap-northeast-2.amazonaws.com/default/wework-lambda-debug-20190618',
//               data: {
//                 isDebug: tool_app.isDebug,
//                 'c': 'console.log("asd");',
//                 'cmd': cmd,
//                 'params': p,
//                 'greeter': 'asd',
//               },
//               headers: {
//                 'x-api-key': 'FzNOh8Zswn8vt0gJ8Rm8g6daOifpYrlz1EdrSYVM',
//                 'Content-Type': 'application/json',
//                 'Authorization': data.idToken.jwtToken,
//               }
//             })
//               .then(function (response) {
//                 // response.data.pipe(fs.createWriteStream('ada_lovelace.jpg'))
//                 lg('cmd 2 response: ', response);
//                 lg('cmd 2 log:', response.data.log);
//                 resolve(response);
//                 // console.log('response:', response)
//                 // response.data.results.forEach(function (element) {
//                 //   console.log(element)
//                 // })
//               })
//               .catch((reason) => {
//                 // TODO error dialog 띄워야 함
//                 lg('cmd 2 reason: ', reason);
//               })
//               .finally(() => {
//                 lg('cmd 2 finally: ', cmdb.modal);
//                 if(cmdb.modal) {
//                   // lg('cmd 3 finally: ', cmdb.modal);
//                   comp.$modal.hide('progress');
//                 }
//               })
//           })
//           .catch(err => {
//             tool_app.ex(err);
//             if(cmdb.modal) {
//               comp.$modal.hide('progress');
//             }
//             reject(err);
//           });
//       });
//     };
//     return cmdb;
  },




//   api: function (comp, q, p) {
//     return new Promise(function (resolve, reject) {
//       // $.get('url 주소/products/1', function (response) {
//       //   // 데이터를 받으면 resolve() 호출
//       //   resolve(response);
//       // });
//
//       Auth.currentSession()
//         .then(data => {
//           lg('api 1 data: ', data);
//
//           // {
//           //   "query": "SELECT * FROM `table_name` ORDER BY column_1 DESC LIMIT 50",
//           //   "params": [10000],
//           //   "greeter": "asd"
//           // }
//
//           axios({
//             method: 'post', // you can set what request you want to be
//             url: 'https://b2mmnijy50.execute-api.ap-northeast-2.amazonaws.com/default/wework-lambda-debug-20190618',
//             data: {
//               'c': 'console.log("asd");',
//               // 'query': 'SELECT * FROM `table_name` ORDER BY column_1 DESC LIMIT 50',
//               // 'params': [Math.random() * 10000],
//               'query': q,
//               'params': p,
//               'greeter': 'asd',
//             },
//             headers: {
//               'x-api-key': 'FzNOh8Zswn8vt0gJ8Rm8g6daOifpYrlz1EdrSYVM',
//               'Content-Type': 'application/json',
//               'Authorization': data.idToken.jwtToken,
//             }
//           })
//             .then(function (response) {
//               // response.data.pipe(fs.createWriteStream('ada_lovelace.jpg'))
//               lg('api 2 response: ', response);
//               resolve(response);
//               // console.log('response:', response)
//               // response.data.results.forEach(function (element) {
//               //   console.log(element)
//               // })
//             })
//             .catch((reason) => {
//               // TODO error dialog 띄워야 함
//               lg('cmd 2 reason: ', reason);
//             })
//         })
//         .catch(err => {
//           tool_app.ex(err);
//           reject(err);
//         });
//     });
//   },
//   cmd: function (comp, cmd, p) {
//
//     let cmdb = {
//       modal: false,
//     };
//     cmdb.setShowProgressDialog = () => {
//       cmdb.modal = true;
//       comp.$modal.show({
//           template: `
// <div style="padding-left:10px; padding-right: 10px;">
//           <v-progress-linear :indeterminate="true"></v-progress-linear>
// </div>
//       `,
//           props: ['text', 'foo']
//         }, {
//           text: 'This text is passed as a property',
//         }, {
//           name: 'progress',
//           width: 200,
//           height: 'auto',
//           // clickToClose: false,
//         },
//       );
//       return cmdb;
//     };
//     cmdb.send = () => {
//       return new Promise(function (resolve, reject) {
//         Auth.currentSession()
//           .then(data => {
//             lg('api 1 data: ', data);
//
//             // {
//             //   "cmd": "ASD",
//             //   "params": [10000],
//             //   "greeter": "asd"
//             // }
//             axios({
//               method: 'post', // you can set what request you want to be
//               url: 'https://b2mmnijy50.execute-api.ap-northeast-2.amazonaws.com/default/wework-lambda-debug-20190618',
//               data: {
//                 isDebug: tool_app.isDebug,
//                 'c': 'console.log("asd");',
//                 'cmd': cmd,
//                 'params': p,
//                 'greeter': 'asd',
//               },
//               headers: {
//                 'x-api-key': 'FzNOh8Zswn8vt0gJ8Rm8g6daOifpYrlz1EdrSYVM',
//                 'Content-Type': 'application/json',
//                 'Authorization': data.idToken.jwtToken,
//               }
//             })
//               .then(function (response) {
//                 // response.data.pipe(fs.createWriteStream('ada_lovelace.jpg'))
//                 lg('cmd 2 response: ', response);
//                 lg('cmd 2 log:', response.data.log);
//                 resolve(response);
//                 // console.log('response:', response)
//                 // response.data.results.forEach(function (element) {
//                 //   console.log(element)
//                 // })
//               })
//               .catch((reason) => {
//                 // TODO error dialog 띄워야 함
//                 lg('cmd 2 reason: ', reason);
//               })
//               .finally(() => {
//                 lg('cmd 2 finally: ', cmdb.modal);
//                 if(cmdb.modal) {
//                   // lg('cmd 3 finally: ', cmdb.modal);
//                   comp.$modal.hide('progress');
//                 }
//               })
//           })
//           .catch(err => {
//             tool_app.ex(err);
//             if(cmdb.modal) {
//               comp.$modal.hide('progress');
//             }
//             reject(err);
//           });
//       });
//     };
//     return cmdb;
//   },

  isNumber (pidx) {
    if(!pidx) {
      return false;
    }
    if(typeof pidx === 'number') {
      return true;
    }
    if(Number.isInteger(pidx) === false) {
      return false;
    }
    return true;
  },


  isNumeric(pidx) {
    if(!pidx) {
      return false;
    }
    if(typeof pidx === 'number') {
      return true;
    }
    if(typeof pidx === 'string') {
      try {
        // tool_app.lg('isNumber 2 pidx:', pidx);
        let s = pidx.replace(/^\s*|\s*$/g, ''); // 좌우 공백 제거
        // tool_app.lg('isNumber 3 s:', s);
        if (s === '' || isNaN(s)) return false;
        // tool_app.lg('isNumber 4 s:', s);
      } catch (e) {
      }
    }
    return true;
  },

  isStringBlank (str) {
    if(!str) {
      return true;
    }
    if(str.length <= 0) {
      return true;
    }
    return false;
  },
  initComp(comp) {
    comp.comp = comp;
    comp.tool_app = tool_app;

    return comp;
  },
};
// let a = {
// }
// let bb = function () {
//   function asd () {
//
//   }
// }
export default tool_app;

// Vue.prototype.tool_app = {
//   api: function(q, p) {
//     Auth.currentSession()
//       .then(data => {
//         console.log(data)
//
//         axios({
//           method: 'post', // you can set what request you want to be
//           url: 'https://b2mmnijy50.execute-api.ap-northeast-2.amazonaws.com/default/wework-lambda-debug-20190618',
//           data: {
//             'c': 'console.log("asd");',
//             // 'query': 'SELECT * FROM `table_name` ORDER BY column_1 DESC LIMIT 50',
//             // 'params': [Math.random() * 10000],
//             'query': q,
//             'params': p,
//             'greeter': 'asd',
//           },
//           headers: {
//             'x-api-key': 'FzNOh8Zswn8vt0gJ8Rm8g6daOifpYrlz1EdrSYVM',
//             'Content-Type': 'application/json',
//             'Authorization': data.idToken.jwtToken,
//           }
//         })
//           .then(function (response) {
//             // response.data.pipe(fs.createWriteStream('ada_lovelace.jpg'))
//             console.log('response:', response)
//             // response.data.results.forEach(function (element) {
//             //   console.log(element)
//             // })
//           })
//       })
//       .catch(err => console.log(err))
//   }
// };
// export default Vue.prototype.tool_app;
